import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col justify-center min-h-full py-12 sm:px-6 lg:px-8"
}
const _hoisted_2 = { class: "mt-8 sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = { class: "bg-white py-8 px-4 shadow-sm sm:rounded-lg sm:px-10" }
const _hoisted_4 = {
  id: "form-reset-password",
  class: "space-y-6"
}
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col justify-center min-h-full py-12 sm:px-6 lg:px-8"
}

import {ref} from "vue";
import {client} from '@/shared';
import {ResetPassword} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
    token: {
        default: ''
    }
},
  setup(__props) {

// @ts-ignore
const props = __props

const token = ref(props.token);
const password = ref('');
const repeatPassword = ref('');
const isSubmitting = ref(false);
const submitted = ref(false);
const responseStatus = ref(null);

const submit = async () => {
    isSubmitting.value = true;
    await client.post(new ResetPassword({
        token: token.value,
        password: password.value,
        repeatPassword: repeatPassword.value,
    }))
        .then(() => {
            submitted.value = true;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo(0,100);
        });
    isSubmitting.value = false;
};

return (_ctx: any,_cache: any) => {
  return (!submitted.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sm:mx-auto sm:w-full sm:max-w-md" }, [
          _createElementVNode("h2", { class: "mt-6 text-center text-3xl font-extrabold text-gray-900" }, "Reset Your Account Password"),
          _createElementVNode("p", { class: "mt-2 text-center text-sm text-gray-600" }, " Your password must be at least 6 characters long and must contain at least one uppercase, one lowercase, and one numerical character. ")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", _hoisted_4, [
              _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
              _createElementVNode("div", null, [
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                  for: "password",
                  class: "block text-sm font-medium text-gray-700"
                }, " Password ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                    id: "password",
                    name: "password",
                    type: "password",
                    required: "",
                    class: "appearance-none block w-full px-3 py-2 border border-clay-500 rounded-md shadow-sm placeholder-gray-400 focus:outline-hidden focus:ring-electric-500 focus:border-electric-500 sm:text-sm"
                  }, null, 512), [
                    [_vModelText, password.value]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[3] || (_cache[3] = _createElementVNode("label", {
                  for: "repeatPassword",
                  class: "block text-sm font-medium text-gray-700"
                }, " Repeat Password ", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((repeatPassword).value = $event)),
                    id: "repeatPassword",
                    name: "repeatPassword",
                    type: "password",
                    required: "",
                    class: "appearance-none block w-full px-3 py-2 border border-clay-500 rounded-md shadow-sm placeholder-gray-400 focus:outline-hidden focus:ring-electric-500 focus:border-electric-500 sm:text-sm"
                  }, null, 512), [
                    [_vModelText, repeatPassword.value]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(SaButton, {
                  disabled: !password.value || !repeatPassword.value,
                  onClick: _withModifiers(submit, ["prevent"]),
                  loading: isSubmitting.value,
                  variant: "primary"
                }, {
                  loading: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Submitting... ")
                  ])),
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createTextVNode(" Request Password Reset "))
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[7] || (_cache[7] = [
        _createStaticVNode("<div class=\"max-w-4xl mx-auto text-center pro-opp-checkout\"><div class=\"space-y-3\"><h1 class=\"text-3xl font-bold tracking-tight text-gray-900 md:text-4xl\">Password Reset Successful! </h1><p class=\"my-4 text-xl leading-6 text-clay-800\"> Your password has been successfully reset.<br> You can now log in to your account by clicking the link below. </p><p><a class=\"inline-flex items-center px-5 py-3 font-medium text-white uppercase border border-transparent rounded-md shadow-sm t bg-rose-500 hover:bg-rose-600 focus:outline-hidden focus:ring-2 focus:ring-rose-500 focus:ring-offset-2\" href=\"/login\">Login</a></p></div></div>", 1)
      ])))
}
}

})